import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 48%;
    height: 148px;
    margin: 2px auto 0 auto;
    padding: 26px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius};
    box-shadow: 0px 3px 1px rgba(0, 0, 0, 0.1);

    > h3 {
      font-family: ${theme.font.comfortaa};
      font-size: ${theme.font.sizes.xxsmall};
      font-weight: ${theme.font.xbold};
      line-height: 20px;
      color: ${theme.colors.darkGray};
      width: 65%;
      height: 36px;
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;

      > h4 {
        font-family: ${theme.font.comfortaa};
        font-size: ${theme.font.sizes.xxsmall};
        font-weight: ${theme.font.normal};
        color: ${theme.colors.xgray};
        display: flex;
        align-items: center;

        .equal-icon {
          margin-left: 2px;
          padding-bottom: 3px;
        }

        .positive-arrow {
          transform: rotate(270deg);
          margin-left: 8px;
          margin-bottom: 4px;

          path {
            fill: ${theme.colors.secondary};
          }
        }

        .negative-arrow {
          transform: rotate(90deg);
          margin-left: 8px;
          margin-bottom: 4px;

          path {
            fill: ${theme.colors.red};
          }
        }
      }
    }

    ${media.lessThan('medium')`
      width: 96%;
      margin-bottom: 12px;
      padding: 18px
    `}

    ${media.lessThan('small')`
      width: 96%;
      margin-bottom: 12px;

      > h3 {
        width: 80%;
      }

      > div h4 {
        width: 40%;
      }
    `}
  `}
`
